<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="toctitle"><i>Abbreviations</i></h2>
<table style="font-size: 85%;" width="100%">
<colgroup><col width="20%"/>
<col width="80%"/>
</colgroup><tbody><tr>
<td align="left" valign="top">A</td>
<td align="left" valign="top">Allemande</td>
</tr>
<tr>
<td align="left" valign="top">AA</td>
<td align="left" valign="top">Authors Agency of the Polish Music Publishers</td>
</tr>
<tr>
<td align="left" valign="top">ABRSM</td>
<td align="left" valign="top">Associated Board of the Royal Schools of Music</td>
</tr>
<tr>
<td align="left" valign="top">ACA</td>
<td align="left" valign="top">American Composers Alliance</td>
</tr>
<tr>
<td align="left" valign="top">ACF</td>
<td align="left" valign="top">American Composers Forum</td>
</tr>
<tr>
<td align="left" valign="top">AMC</td>
<td align="left" valign="top">American Music Center</td>
</tr>
<tr>
<td align="left" valign="top">AME</td>
<td align="left" valign="top">American Music Editions</td>
</tr>
<tr>
<td align="left" valign="top">AMP</td>
<td align="left" valign="top">Associated Music Publishers</td>
</tr>
<tr>
<td align="left" valign="top">Anh</td>
<td align="left" valign="top">Anhang (appendix)</td>
</tr>
<tr>
<td align="left" valign="top">APS</td>
<td align="left" valign="top">Art Publication Society</td>
</tr>
<tr>
<td align="left" valign="top">B</td>
<td align="left" valign="top">Bourrée</td>
</tr>
<tr>
<td align="left" valign="top">B&amp;UP</td>
<td align="left" valign="top">Broekmans &amp; Van Poppel</td>
</tr>
<tr>
<td align="left" valign="top">BB</td>
<td align="left" valign="top">Broude Brothers</td>
</tr>
<tr>
<td align="left" valign="top">BBD</td>
<td align="left" valign="top">Ellie B. Carlson, <i>A</i> <i>Bibliographical Dictionary</i> <i>of Twelve-Tone and Serial</i> <i>Composers</i> (Metuchen, NJ: Scarecrow Press, 1970)</td>
</tr>
<tr>
<td align="left" valign="top">Bk(s)</td>
<td align="left" valign="top">Book(s)</td>
</tr>
<tr>
<td align="left" valign="top">BMC</td>
<td align="left" valign="top">Boston Music Company</td>
</tr>
<tr>
<td align="left" valign="top">BME</td>
<td align="left" valign="top">Brazilian Music Enterprises</td>
</tr>
<tr>
<td align="left" valign="top">BMI</td>
<td align="left" valign="top">Broadcast Music, Inc.</td>
</tr>
<tr>
<td align="left" valign="top">Bo&amp;Bo</td>
<td align="left" valign="top">Bote &amp; Bock</td>
</tr>
<tr>
<td align="left" valign="top">Bo&amp;H</td>
<td align="left" valign="top">Boosey &amp; Hawkes</td>
</tr>
<tr>
<td align="left" valign="top">Br</td>
<td align="left" valign="top">Bärenreiter</td>
</tr>
<tr>
<td align="left" valign="top">Br&amp;H</td>
<td align="left" valign="top">Breitkopf &amp; Härtel</td>
</tr>
<tr>
<td align="left" valign="top">B&amp;S</td>
<td align="left" valign="top">Boccaccini &amp; Spada</td>
</tr>
<tr>
<td align="left" valign="top">C</td>
<td align="left" valign="top">Courante</td>
</tr>
<tr>
<td align="left" valign="top">ca.</td>
<td align="left" valign="top">circa</td>
</tr>
<tr>
<td align="left" valign="top">CAP</td>
<td align="left" valign="top">Composers' Autograph Publications</td>
</tr>
<tr>
<td align="left" valign="top">CD</td>
<td align="left" valign="top">Compact disc</td>
</tr>
<tr>
<td align="left" valign="top">CeBeDeM</td>
<td align="left" valign="top">CeBeDeM Foundations</td>
</tr>
<tr>
<td align="left" valign="top">CF</td>
<td align="left" valign="top">Carl Fischer</td>
</tr>
<tr>
<td align="left" valign="top">CFE</td>
<td align="left" valign="top">Composers Facsimile Edition</td>
</tr>
<tr>
<td align="left" valign="top">CFP</td>
<td align="left" valign="top">C. F. Peters</td>
</tr>
<tr>
<td align="left" valign="top">CHP</td>
<td align="left" valign="top">Chesky Hudebni Fond</td>
</tr>
<tr>
<td align="left" valign="top">CK</td>
<td align="left" valign="top"><i>Contemporary Keyboard</i></td>
</tr>
<tr>
<td align="left" valign="top">CMC</td>
<td align="left" valign="top">Canadian Music Centre</td>
</tr>
<tr>
<td align="left" valign="top">CMP</td>
<td align="left" valign="top">Consolidated Music Publishing</td>
</tr>
<tr>
<td align="left" valign="top">CPE</td>
<td align="left" valign="top">Composer/Performer Edition</td>
</tr>
<tr>
<td align="left" valign="top">CSMP</td>
<td align="left" valign="top">Crystal Spring Music Publishers</td>
</tr>
<tr>
<td align="left" valign="top">CuMP</td>
<td align="left" valign="top">Columbia University Music Press</td>
</tr>
<tr>
<td align="left" valign="top">D</td>
<td align="left" valign="top">Difficult</td>
</tr>
<tr>
<td align="left" valign="top">DCM</td>
<td align="left" valign="top"><i>Dictionary of Contemporary</i> <i>Music</i>, ed. John Vinton (New York E. P. Dutton, 1974)</td>
</tr>
<tr>
<td align="left" valign="top">DDT</td>
<td align="left" valign="top">Denkmäler deutscher Tonkunst</td>
</tr>
<tr>
<td align="left" valign="top">DoB</td>
<td align="left" valign="top">Doblinger</td>
</tr>
<tr>
<td align="left" valign="top">DTB</td>
<td align="left" valign="top">Denkmäler der Tonkunst in Bayern</td>
</tr>
<tr>
<td align="left" valign="top">DTOe</td>
<td align="left" valign="top">Denkmäler der Tonkunst in Österreich</td>
</tr>
<tr>
<td align="left" valign="top">DVFM</td>
<td align="left" valign="top">Deutscher Verlag für Musik</td>
</tr>
<tr>
<td align="left" valign="top">EAM</td>
<td align="left" valign="top">Editorial Argentina de Música</td>
</tr>
<tr>
<td align="left" valign="top">EAMC</td>
<td align="left" valign="top">European American Music Corporation</td>
</tr>
<tr>
<td align="left" valign="top">EBM</td>
<td align="left" valign="top">E. B. Marks</td>
</tr>
<tr>
<td align="left" valign="top">EC</td>
<td align="left" valign="top">Edizioni Curci</td>
</tr>
<tr>
<td align="left" valign="top">ECIC</td>
<td align="left" valign="top">Editorial Cooperativa Intermericana de Compositores</td>
</tr>
<tr>
<td align="left" valign="top">ECS</td>
<td align="left" valign="top">ECS Publishing (parent to E. C. Schirmer Music)</td>
</tr>
<tr>
<td align="left" valign="top">ed.</td>
<td align="left" valign="top">Edition</td>
</tr>
<tr>
<td align="left" valign="top">EKJ</td>
<td align="left" valign="top"><i>Early Keyboard Journal</i></td>
</tr>
<tr>
<td align="left" valign="top">ELK</td>
<td align="left" valign="top">Elkan &amp; Schildknecht</td>
</tr>
<tr>
<td align="left" valign="top">EMB</td>
<td align="left" valign="top">Editio Musica Budapest</td>
</tr>
<tr>
<td align="left" valign="top">EMH</td>
<td align="left" valign="top">Editions Musikk-Huset</td>
</tr>
<tr>
<td align="left" valign="top">EmM</td>
<td align="left" valign="top">Editions musicales du Marais</td>
</tr>
<tr>
<td align="left" valign="top">EMM</td>
<td align="left" valign="top">Ediciones Mexicanas de Música</td>
</tr>
<tr>
<td align="left" valign="top">EMT</td>
<td align="left" valign="top">Editions Musicales Transatlantiques</td>
</tr>
<tr>
<td align="left" valign="top">ESC</td>
<td align="left" valign="top">Max Eschig</td>
</tr>
<tr>
<td align="left" valign="top">EV</td>
<td align="left" valign="top">Elkan-Vogel</td>
</tr>
<tr>
<td align="left" valign="top">ff</td>
<td align="left" valign="top">Fortissimo</td>
</tr>
<tr>
<td align="left" valign="top">fl</td>
<td align="left" valign="top">Flute</td>
</tr>
<tr>
<td align="left" valign="top">flou</td>
<td align="left" valign="top">Flourished</td>
</tr>
<tr>
<td align="left" valign="top">FSF</td>
<td align="left" valign="top">Fast–Slow–Fast</td>
</tr>
<tr>
<td align="left" valign="top">FVB</td>
<td align="left" valign="top">Fitzwilliam Virginial Book</td>
</tr>
<tr>
<td align="left" valign="top">G</td>
<td align="left" valign="top">Gigue</td>
</tr>
<tr>
<td align="left" valign="top">Gen</td>
<td align="left" valign="top">General Music Publishing Company</td>
</tr>
<tr>
<td align="left" valign="top">GM</td>
<td align="left" valign="top">Gehrmans Musikförlag</td>
</tr>
<tr>
<td align="left" valign="top">GS</td>
<td align="left" valign="top">G. Schirmer</td>
</tr>
<tr>
<td align="left" valign="top">GWM</td>
<td align="left" valign="top">General Words and Music</td>
</tr>
<tr>
<td align="left" valign="top">Hin</td>
<td align="left" valign="top">Hinrichsen</td>
</tr>
<tr>
<td align="left" valign="top">HV</td>
<td align="left" valign="top">Heinrichshofens Verlag</td>
</tr>
<tr>
<td align="left" valign="top">IEM</td>
<td align="left" valign="top">Instituto de Extensión Musicale</td>
</tr>
<tr>
<td align="left" valign="top">IMC</td>
<td align="left" valign="top">International Music Company</td>
</tr>
<tr>
<td align="left" valign="top">IMI</td>
<td align="left" valign="top">Israel Music Institute</td>
</tr>
<tr>
<td align="left" valign="top">IMP</td>
<td align="left" valign="top">Israeli Music Publications</td>
</tr>
<tr>
<td align="left" valign="top">Int.</td>
<td align="left" valign="top">Intermediate difficulty</td>
</tr>
<tr>
<td align="left" valign="top">ITO</td>
<td align="left" valign="top"><i>In Theory Only</i> (journal)</td>
</tr>
<tr>
<td align="left" valign="top">IU</td>
<td align="left" valign="top">William and Gayle Cook Music Library, Indiana University</td>
</tr>
<tr>
<td align="left" valign="top">JALS</td>
<td align="left" valign="top"><i>Journal of the American Liszt Society</i></td>
</tr>
<tr>
<td align="left" valign="top">JF</td>
<td align="left" valign="top">J. Fischer</td>
</tr>
<tr>
<td align="left" valign="top">JFC</td>
<td align="left" valign="top">Japan Federation of Composers</td>
</tr>
<tr>
<td align="left" valign="top">JWC</td>
<td align="left" valign="top">J. W. Chester</td>
</tr>
<tr>
<td align="left" valign="top">K</td>
<td align="left" valign="top">Kalmus</td>
</tr>
<tr>
<td align="left" valign="top">KC</td>
<td align="left" valign="top"><i>Keyboard Classics</i></td>
</tr>
<tr>
<td align="left" valign="top">KMB</td>
<td align="left" valign="top">Konemann Music Budapest</td>
</tr>
<tr>
<td align="left" valign="top">K&amp;S</td>
<td align="left" valign="top">Kistner &amp; Siegel</td>
</tr>
<tr>
<td align="left" valign="top">Ku</td>
<td align="left" valign="top">Kultura</td>
</tr>
<tr>
<td align="left" valign="top">L</td>
<td align="left" valign="top">Alessandro Longo</td>
</tr>
<tr>
<td align="left" valign="top">LAMR</td>
<td align="left" valign="top"><i>Latin American Music Review</i></td>
</tr>
<tr>
<td align="left" valign="top">LC</td>
<td align="left" valign="top">Library of Congress, Washington, DC</td>
</tr>
<tr>
<td align="left" valign="top">LG</td>
<td align="left" valign="top">Lawson Gould</td>
</tr>
<tr>
<td align="left" valign="top">l'OL</td>
<td align="left" valign="top">l'Oiseau-Lyre</td>
</tr>
<tr>
<td align="left" valign="top">M</td>
<td align="left" valign="top">Minuet</td>
</tr>
<tr>
<td align="left" valign="top">MAB</td>
<td align="left" valign="top">Musica Antiqua Bohemica (Artia)</td>
</tr>
<tr>
<td align="left" valign="top">MCA</td>
<td align="left" valign="top">MCA Music</td>
</tr>
<tr>
<td align="left" valign="top">M-D</td>
<td align="left" valign="top">Moderately Difficult</td>
</tr>
<tr>
<td align="left" valign="top">Mer</td>
<td align="left" valign="top">Mercury Music Corporation</td>
</tr>
<tr>
<td align="left" valign="top">MFTP</td>
<td align="left" valign="top">James Friskin and Irwin Freundlich, <i>Music for the</i> <i>Piano</i> (New York: Rinehart, 1954; reprint New York: Dover, 1973)</td>
</tr>
<tr>
<td align="left" valign="top">MGP</td>
<td align="left" valign="top">Music Graphics Press</td>
</tr>
<tr>
<td align="left" valign="top">MJ</td>
<td align="left" valign="top"><i>Music Journal</i></td>
</tr>
<tr>
<td align="left" valign="top">MJQ</td>
<td align="left" valign="top">MJQ Music</td>
</tr>
<tr>
<td align="left" valign="top">ML</td>
<td align="left" valign="top"><i>Music and Letters</i></td>
</tr>
<tr>
<td align="left" valign="top">MM</td>
<td align="left" valign="top"><i>Modern Music</i></td>
</tr>
<tr>
<td align="left" valign="top">M&amp;M</td>
<td align="left" valign="top"><i>Music and Musicians</i></td>
</tr>
<tr>
<td align="left" valign="top">MMB</td>
<td align="left" valign="top">MMB Music</td>
</tr>
<tr>
<td align="left" valign="top">MMP</td>
<td align="left" valign="top">Master Music Publications</td>
</tr>
<tr>
<td align="left" valign="top">MMR</td>
<td align="left" valign="top"><i>Monthly Musical Record</i></td>
</tr>
<tr>
<td align="left" valign="top">MO</td>
<td align="left" valign="top"><i>Musical Opinion</i></td>
</tr>
<tr>
<td align="left" valign="top">MQ</td>
<td align="left" valign="top"><i>Musician Quarterly</i></td>
</tr>
<tr>
<td align="left" valign="top">MR</td>
<td align="left" valign="top"><i>Music Review</i></td>
</tr>
<tr>
<td align="left" valign="top">MS(S)</td>
<td align="left" valign="top">manuscript(s)</td>
</tr>
<tr>
<td align="left" valign="top">MT</td>
<td align="left" valign="top"><i>Musical Times</i></td>
</tr>
<tr>
<td align="left" valign="top">mt(s)</td>
<td align="left" valign="top">movement(s)</td>
</tr>
<tr>
<td align="left" valign="top">MTNA</td>
<td align="left" valign="top">Music Teachers National Association</td>
</tr>
<tr>
<td align="left" valign="top">MTP</td>
<td align="left" valign="top">Music Treasure Publications</td>
</tr>
<tr>
<td align="left" valign="top">MVH</td>
<td align="left" valign="top">Musica Viva Historica (Artia)</td>
</tr>
<tr>
<td align="left" valign="top">Nag</td>
<td align="left" valign="top">Nagel's Music-Archive</td>
</tr>
<tr>
<td align="left" valign="top">NGD</td>
<td align="left" valign="top"><i>New Grove Dictionary of</i> <i>Music and Musicians, 2nd</i> <i>Edition</i></td>
</tr>
<tr>
<td align="left" valign="top">NLE</td>
<td align="left" valign="top">New Liszt Edition (<i>Liszt</i> <i>Neue Ausgabe sämtlicher</i> <i>Werke</i>)</td>
</tr>
<tr>
<td align="left" valign="top">NME</td>
<td align="left" valign="top">New Music Edition</td>
</tr>
<tr>
<td align="left" valign="top">NMO</td>
<td align="left" valign="top">Norsk Musikförlag</td>
</tr>
<tr>
<td align="left" valign="top">NMS</td>
<td align="left" valign="top">Nordiska Musikförlaget</td>
</tr>
<tr>
<td align="left" valign="top">Nov</td>
<td align="left" valign="top">Novello</td>
</tr>
<tr>
<td align="left" valign="top">NV</td>
<td align="left" valign="top">Noetzel Verlag</td>
</tr>
<tr>
<td align="left" valign="top">OBV</td>
<td align="left" valign="top">Oesterreischer Bundesverlag</td>
</tr>
<tr>
<td align="left" valign="top">OD</td>
<td align="left" valign="top">Oliver Ditson</td>
</tr>
<tr>
<td align="left" valign="top">Op.</td>
<td align="left" valign="top">Opus</td>
</tr>
<tr>
<td align="left" valign="top">OUP</td>
<td align="left" valign="top">Oxford University Press</td>
</tr>
<tr>
<td align="left" valign="top">PaF</td>
<td align="left" valign="top">Prelude and Fugue</td>
</tr>
<tr>
<td align="left" valign="top">PAU</td>
<td align="left" valign="top">Pan American Union</td>
</tr>
<tr>
<td align="left" valign="top">PF</td>
<td align="left" valign="top">Performers' Facsimiles</td>
</tr>
<tr>
<td align="left" valign="top">PIC</td>
<td align="left" valign="top">Peer International Corporation</td>
</tr>
<tr>
<td align="left" valign="top">P&amp;K</td>
<td align="left" valign="top"><i>Piano and Keyboard</i></td>
</tr>
<tr>
<td align="left" valign="top">PMP</td>
<td align="left" valign="top">Polish Music Publications</td>
</tr>
<tr>
<td align="left" valign="top">PNM</td>
<td align="left" valign="top"><i>Perspectives of New Music</i></td>
</tr>
<tr>
<td align="left" valign="top">pp</td>
<td align="left" valign="top">Pianissimo</td>
</tr>
<tr>
<td align="left" valign="top">PQ</td>
<td align="left" valign="top"><i>Piano Quarterly</i></td>
</tr>
<tr>
<td align="left" valign="top">PRMA</td>
<td align="left" valign="top"><i>Proceedings of the Royal Musical Association</i></td>
</tr>
<tr>
<td align="left" valign="top">PSM</td>
<td align="left" valign="top">Pennyslvania State Music Series (Pennyslvania State University Press)</td>
</tr>
<tr>
<td align="left" valign="top">PWM</td>
<td align="left" valign="top">Polskie Wydawnictwo Muzyczne</td>
</tr>
<tr>
<td align="left" valign="top">QT</td>
<td align="left" valign="top">Queen's Temple Publications</td>
</tr>
<tr>
<td align="left" valign="top">R&amp;E</td>
<td align="left" valign="top">Ries &amp; Erier</td>
</tr>
<tr>
<td align="left" valign="top">Rev.</td>
<td align="left" valign="top">Revised</td>
</tr>
<tr>
<td align="left" valign="top">Ric</td>
<td align="left" valign="top">Ricordi</td>
</tr>
<tr>
<td align="left" valign="top">Ric Amer</td>
<td align="left" valign="top">Ricordi Americana S.A.</td>
</tr>
<tr>
<td align="left" valign="top">Ric BR</td>
<td align="left" valign="top">Ricordi Brazil</td>
</tr>
<tr>
<td align="left" valign="top">RMP</td>
<td align="left" valign="top">Russian Music Publishers</td>
</tr>
<tr>
<td align="left" valign="top">S</td>
<td align="left" valign="top">Sarabande</td>
</tr>
<tr>
<td align="left" valign="top">SA</td>
<td align="left" valign="top">Sonata-Allegro</td>
</tr>
<tr>
<td align="left" valign="top">Sal</td>
<td align="left" valign="top">Salabert</td>
</tr>
<tr>
<td align="left" valign="top">SB</td>
<td align="left" valign="top">Summy-Birchard</td>
</tr>
<tr>
<td align="left" valign="top">S&amp;B</td>
<td align="left" valign="top">Steiner &amp; Bell</td>
</tr>
<tr>
<td align="left" valign="top">SBE</td>
<td align="left" valign="top">William S. Newman, <i>The Sonata in the Baroque Era</i> (Chapel Hill: University of North Carolina Press, 1959; rev. ed., 1966; 3rd ed. New York: W. W. Norton, 1972)</td>
</tr>
<tr>
<td align="left" valign="top">SBTS</td>
<td align="left" valign="top">Boyce Centennial Library, the Southern Baptist Theological Seminary, Louisville, Kentucky, <a href="http://www.library.sbts.edu/music-and-av-library" target="_blank">www.library.sbts.edu/music-and-av-library</a></td>
</tr>
<tr>
<td align="left" valign="top">SCE</td>
<td align="left" valign="top">William S. Newman, <i>The Sonata in the Classical Era</i> (Chapel Hill: University of North Carolina Press, 1963; 2nd ed., New York: W. W. Norton, 1972)</td>
</tr>
<tr>
<td align="left" valign="top">SDM</td>
<td align="left" valign="top">Servico de Documentacão Musical da Ordem dos Musicos do Brasil</td>
</tr>
<tr>
<td align="left" valign="top">SFS</td>
<td align="left" valign="top">Slow–Fast–Slow</td>
</tr>
<tr>
<td align="left" valign="top">SHKY</td>
<td align="left" valign="top">Frank E. Kirby, <i>Music for Piano: A Short History</i> (Portland, OR: Amadeus Press, 1995)</td>
</tr>
<tr>
<td align="left" valign="top">SHV</td>
<td align="left" valign="top">Státní hudbeni vydavatelstí</td>
</tr>
<tr>
<td align="left" valign="top">SIMG</td>
<td align="left" valign="top">Sammelbände der Internationalen Musikgesellschaft</td>
</tr>
<tr>
<td align="left" valign="top">SKABO</td>
<td align="left" valign="top">Skandinavisk og Borups Musikförlag</td>
</tr>
<tr>
<td align="left" valign="top">SM</td>
<td align="left" valign="top">Skandinavisk Musikförlag</td>
</tr>
<tr>
<td align="left" valign="top">SME</td>
<td align="left" valign="top">Special Music Edition</td>
</tr>
<tr>
<td align="left" valign="top">SP</td>
<td align="left" valign="top">Shawnee Press</td>
</tr>
<tr>
<td align="left" valign="top">SSB</td>
<td align="left" valign="top">William S. Newman, <i>The Sonata Since Beethoven</i> (Chapel Hill: University of North Carolina Press, 1969; 2nd ed., New York: W. W. Norton, 1972)</td>
</tr>
<tr>
<td align="left" valign="top">SZ</td>
<td align="left" valign="top">Suvini Zerboni</td>
</tr>
<tr>
<td align="left" valign="top">ta</td>
<td align="left" valign="top">Tambourine</td>
</tr>
<tr>
<td align="left" valign="top">ti</td>
<td align="left" valign="top">Triangle</td>
</tr>
<tr>
<td align="left" valign="top">TM</td>
<td align="left" valign="top">Jeffrey Kresky, <i>Tonal Music</i> (Bloomington: Indiana University Press, 1977).</td>
</tr>
<tr>
<td align="left" valign="top">TP</td>
<td align="left" valign="top">Theodore Presser</td>
</tr>
<tr>
<td align="left" valign="top">TPA</td>
<td align="left" valign="top"><i>Antologia de musica antica e moderna per il pianoforte</i>, ed. Gino Tagliapietra, 18 vols. (Milan: Ricordi, 1931–32).</td>
</tr>
<tr>
<td align="left" valign="top">UE</td>
<td align="left" valign="top">Universal Edition</td>
</tr>
<tr>
<td align="left" valign="top">UK</td>
<td align="left" valign="top">Lucille Caudill Little Fine Arts Library, University of Kentucky, Lexington, <a href="http://www.uky.edu/FineArts/Music/musicology/resources/library" target="_blank">www.uky.edu/FineArts/Music/musicology/resources/library</a></td>
</tr>
<tr>
<td align="left" valign="top">UL</td>
<td align="left" valign="top">Dwight Anderson Music Library, University of Louisville, Kentucky, <a href="http://www.louisville.edu/library/music" target="_blank">www.louisville.edu/library/music</a></td>
</tr>
<tr>
<td align="left" valign="top">UME</td>
<td align="left" valign="top">Unión Musical Española</td>
</tr>
<tr>
<td align="left" valign="top">UMEd</td>
<td align="left" valign="top">Unión Musical Ediciones</td>
</tr>
<tr>
<td align="left" valign="top">UMKR</td>
<td align="left" valign="top">Unbekannte Meister der Klassik und Romantik (Boonin)</td>
</tr>
<tr>
<td align="left" valign="top">UMP</td>
<td align="left" valign="top">United Music Publishers</td>
</tr>
<tr>
<td align="left" valign="top">UNC</td>
<td align="left" valign="top">University of North Carolina Press</td>
</tr>
<tr>
<td align="left" valign="top">USSR</td>
<td align="left" valign="top">Mezhdunarodnaya Kniga (Music Publishers of the USSR)</td>
</tr>
<tr>
<td align="left" valign="top">Var(s).</td>
<td align="left" valign="top">Variation(s)</td>
</tr>
<tr>
<td align="left" valign="top">vc</td>
<td align="left" valign="top">cello</td>
</tr>
<tr>
<td align="left" valign="top">vl</td>
<td align="left" valign="top">violin</td>
</tr>
<tr>
<td align="left" valign="top">vol(s).</td>
<td align="left" valign="top">Volume(s)</td>
</tr>
<tr>
<td align="left" valign="top">VU</td>
<td align="left" valign="top">Vienna Urtext Edition (UE)</td>
</tr>
<tr>
<td align="left" valign="top">w/</td>
<td align="left" valign="top">with</td>
</tr>
<tr>
<td align="left" valign="top">WB</td>
<td align="left" valign="top">Warner Brothers</td>
</tr>
<tr>
<td align="left" valign="top">WH</td>
<td align="left" valign="top">Wilhelm Hansen</td>
</tr>
<tr>
<td align="left" valign="top">WIN</td>
<td align="left" valign="top">Western International Music</td>
</tr>
<tr>
<td align="left" valign="top">YMP</td>
<td align="left" valign="top">Yorktown Music Press</td>
</tr>
<tr>
<td align="left" valign="top">ZV</td>
<td align="left" valign="top">Zenemükiado Vállala</td>
</tr>
</tbody></table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?19ea40a9